module.exports = __webpack_public_path__ + "/static/assets/ab0416faa2a79b8421eaed13ab25dd4b.gif";